module.exports = __webpack_public_path__ + "static/media/am-edit.3f4f62bf.svg";